module.exports = __webpack_public_path__ + "img/electron-choose@2x.658e0b17.png";